module.exports = __webpack_public_path__ + "img/Site@2x.7e4e44cc.png";